import {FunctionComponent} from "react";
import {useNavigate} from 'react-router-dom';
import HanButton from "../../../utils/HanButton";

interface Props {
    isGray?: boolean;
}

const FavoriteButton: FunctionComponent<Props> = ({isGray}) => {
    const navigate = useNavigate();

    return (
        <HanButton onClick={() => navigate('/favorites')} star={true}
                   modifiers={isGray ? 'gray' : '-'}>Favorites</HanButton>
    );
}

export default FavoriteButton;